module.exports = {
  colors: {
    black: "#000",
    white: "#fff",
    primary: {
      DEFAULT: "#8639ff",
    },
    slate: {
      DEFAULT: "#F8FAFC",
      50: "#F8FAFC",
      200: "#E3E8F0",
      300: "#CCD5E0",
      500: "#66748A",
      600: "#4E5B6F",
      700: "#354154",
      800: "#1F293A",
    },
    green: {
      DEFAULT: "#22A14D",
      dark: "#1F6B3C",
      light: "#8AEDAE",
      50: "#F0FDF4",
      100: "#DDFBE7",
      500: "#2FC362",
      600: "#22A14D",
      700: "#1D7F3F",
      800: "#16a34a",
      900: "#1B956A",
    },
    red: {
      DEFAULT: "#EA4A4B",
      500: "#EA4A4B",
      600: "#D72F31",
      700: "#B52426",
    },
    orange: {
      dark: "#BE451E",
      300: "#FB923C",
      400: "#F69348",
      600: "#F4762D",
    },
    violet: {
      DEFAULT: "#702ED6",
      light: "#C6B6FB",
      lighter: "#EDE9FD",
      dark: "#5725A2",
      600: "#8141E9",
      700: "#7130D6",
      800: "#5F28B3",
    },
    blue: {
      50: "#F0F9FF",
      100: "#CCE9FF",
      700: "#3B65E7",
      800: "#0000FF",
      900: "#2D42AC",
    },
    gray: {
      200: "#DFDFE2",
    },
    yellow: {
      DEFAULT: "#F1BC1E",
      600: "#F1BC1E",
    },
  },
};
